import ScribeTransport from 'static/script/app/data/scribe-transport';
import NavigationTimeMetrics from 'static/script/app/data/navigation-time-metrics';
import PerformanceMetrics from 'static/script/app/data/performance-metrics';

module.exports = initData => {
    ScribeTransport.attachTo(document, {
        context: {
            client: 'web',
            page: initData.pageName,
            area: initData.areaName,
            path: window.location.pathname
        }
    });

    if (initData.enableTimeMetrics) {
        NavigationTimeMetrics.attachTo(document, {
            pageName: initData.pageName,
            areaName: initData.areaName
        });
        PerformanceMetrics.attachTo(document);
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/boot/boot-scribe-and-metrics.js